/* eslint-disable react-hooks/exhaustive-deps */
import { Auth, Hub } from 'aws-amplify';
import { History } from 'history';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import { useComponentDidMount } from 'src/hooks';
import { setAuthenticated, setUserName } from 'src/redux/auth/authSlice';
import { IRootState } from 'src/redux/rootReducer';
import { Navigator, TokenService } from 'src/services';
import { getRoutePortal } from './helpers';

const AuthContainer: React.FC<Props> = ({
  history,
  isAuthenticated,
  onSetAuth,
  onSetUserName,
  isWelcomeScreen,
}) => {
  // =========================== Didmount ===========================
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const type = query.get('type') || '';

  useEffect(() => {
    Hub.listen('auth', authLogin);
    // 1.call this first when mount because history listen fire when route changed
    // authenticate();
    return () => {
      Hub.remove('auth', authLogin);
    };
  }, [isAuthenticated, isWelcomeScreen]);

  useComponentDidMount(async () => {
    try {
      await TokenService.getToken();
      authenticate();
    } catch (error) {
      clearAuth();
    }
  });

  const authLogin = (res: { payload: { event: string; data?: any } }) => {
    const { payload } = res;
    const { event } = payload;
    switch (event) {
      case 'signIn':
        if (!isWelcomeScreen) {
          authenticate();
        }
        break;
      case 'signOut':
        clearAuth();
        break;
      case 'signIn_failure':
        console.log('signin error', payload?.data?.message);
        break;
      default:
        break;
    }
  };

  const clearAuth = () => {
    onSetAuth(false);
  };

  const authenticate = () => {
    if (type.includes('logout')) {
      localStorage.clear();
      query.delete('type');
      history.push({ search: query.toString() });
      clearAuth();
    }
    if (!isAuthenticated) {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          const userAttributes = user.attributes;

          const portal = userAttributes['custom:portal'];
          const token = user['signInUserSession']['idToken']['payload']['token'] || '';

          Navigator.jumpToSalesForceWeb({
            portal: getRoutePortal(portal),
            params: token,
          });
        })
        .catch(() => {
          clearAuth();
        });
    }
  };

  return null;
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & { history: History };

const mapStateToProps = (state: IRootState) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isWelcomeScreen: state.auth.isWelcomeScreen,
});

const mapDispatchToProps = {
  onSetAuth: setAuthenticated,
  onSetUserName: setUserName,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthContainer));
